import { render, staticRenderFns } from "./EmptyChart.vue?vue&type=template&id=2e637610&scoped=true"
import script from "./EmptyChart.vue?vue&type=script&lang=js"
export * from "./EmptyChart.vue?vue&type=script&lang=js"
import style0 from "./EmptyChart.vue?vue&type=style&index=0&id=2e637610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e637610",
  null
  
)

export default component.exports